<script lang="ts">
  import { Button, Icon, Input, Label } from "sveltestrap";
  import type { Vehicle } from "../Model/Vehicle";
  import { dateInputFormatter } from "../services/Functions";
  import { vehiclesService } from "../services";
  import ParamSelect from "./ParamSelect.svelte";
  import ThirdName from "./ThirdName.svelte";
  import AddThirdModal from "./AddThirdModal.svelte";
  import ThirdNameInput from "./ThirdNameInput.svelte";

  let today = dateInputFormatter(new Date());
  let addThird = false;
  let thirdId = null;
  let type = null;

  export let vehicleData: Vehicle;
  export let viewThird: boolean = true;

  export async function saveVehicleData() {
    if (!vehicleData.plate) return;
    await vehiclesService.saveVehicle(vehicleData);
  }

  function addNewThird(third, type) {
    if(type === 'third') {
      vehicleData.thirdId = third.id;
    } 

    if(type === 'insurance') {
      vehicleData.insuranceTakerId = third.id;
    }
    
  }
  
  function toggle() {
    addThird = !addThird
  }
</script>

{#if vehicleData}
  <div class="row">
    <div class="col-12 col-sm-4 mb-3">
      <Label for="mark">Tipo de vehículo</Label>
      <ParamSelect
        bind:paramSelectId={vehicleData.vehicleType}
        paramType="vehicletype"
        nothing={true}
      />
    </div>
    <div class="col-12 col-sm-4 mb-3">
      <Label for="mark">Marca</Label>
      <ParamSelect
        bind:paramSelectId={vehicleData.markId}
        paramType="vehicleMark"
        nothing={true}
      />
    </div>
    <div class="col-12 col-sm-4 mb-3">
      <Label for="mark">Modelo</Label>
      <ParamSelect
        bind:paramSelectId={vehicleData.modelId}
        paramType="vehicleModel"
        nothing={true}
      />
    </div>
    <div class="col-12 col-sm-4 mb-3">
      <Label for="surname2">Matrícula</Label>
      <Input type="text" bind:value={vehicleData.plate} />
    </div>
    <div class="col-12 col-sm-4 mb-3">
      <Label for="email">Fecha Matriculación</Label>
      <input
        class="form-control"
        type="date"
        value={dateInputFormatter(vehicleData.plateDate)}
        on:change={(event) =>
          (vehicleData.plateDate = event.currentTarget.value)}
      />
    </div>
    <div class="col-12 col-sm-4 mb-3">
      <Label for="alias">Bastidor</Label>
      <Input type="text" bind:value={vehicleData.frame} />
    </div>
    <div class="col-12 col-sm-4 mb-3">
      <Label for="document">Color</Label>
      <ParamSelect
        bind:paramSelectId={vehicleData.colorId}
        paramType="color"
        nothing={true}
      />
    </div>
    <div class="col-12 col-sm-4 mb-3">
      <Label for="email">Fecha ITV</Label>
      <input
        class="form-control"
        type="date"
        value={dateInputFormatter(vehicleData.validityInpeccion)}
        on:change={(event) =>
          (vehicleData.validityInpeccion = event.currentTarget.value)}
      />
    </div>

    <div class="col-12 mb-3">
      <hr />
    </div>

    <div class="col-12 col-sm-4 mb-3">
      <Label for="phone1">Aseguradora</Label>
      <ParamSelect
        bind:paramSelectId={vehicleData.insuranceCarrierId}
        paramType="insurenceCarrier"
        nothing={true}
      />
    </div>
    <div class="col-12 col-sm-4 mb-3">
      <Label for="phone2">Validez Poliza</Label>
      <input
        class="form-control"
        type="date"
        value={dateInputFormatter(vehicleData.validityPolicy)}
        on:change={(event) =>
          (vehicleData.validityPolicy = event.currentTarget.value)}
      />
    </div>
    <div class="col-12 col-sm-4 mb-3">
      <Label for="phone2">Tomador</Label>
      <div class="input-group">
        <ThirdNameInput id={vehicleData.insuranceTakerId} />
        <button
          class="btn btn-secondary"
          type="button"
          id="complainantThirId"
          name="complainantThirId"
          on:click={() => {
            addThird = true;
            thirdId = vehicleData.insuranceTakerId;
            type = 'insurance'
          }}
        >
          <Icon name="plus" />
        </button>
      </div>
    </div>

    <div class="col-12 col-sm-4 mb-3">
      <Label for="email">Nº Poliza</Label>
      <Input type="text" bind:value={vehicleData.policyNumber} />
    </div>

    <div>
      <hr />
    </div>

    <div class="col-12 col-sm-3 mb-3">
      <Label for="phone2">Tipo de tarjeta transporte</Label>
      <ParamSelect
        bind:paramSelectId={vehicleData.transportCardType}
        paramType="transportCardType"
        nothing={true}
      />
    </div>
    <div class="col-12 col-sm-4 mb-3">
      <Label for="birthday">Tarjeta transporte visible</Label>
      <Input
        id="c1"
        type="checkbox"
        label="Si"
        bind:checked={vehicleData.transportCardTypeVisible}
      />
    </div>
    <div class="col-12 col-sm-4 mb-3">
      <Label for="dateOfDeath">Tarjeta transporte correspondiente</Label>
      <Input
        id="c2"
        type="checkbox"
        label="Si"
        bind:checked={vehicleData.transportCardTypeCorresponding}
      />
    </div>

    {#if viewThird}
      <div>
        <hr />
      </div>
      
      <div class="col-12 mb-3">
        <Label for="phone2">Propietario</Label>

        <ul class="list-group">
          <li
            class="list-group-item d-flex justify-content-between align-items-center"
          >
            <ThirdName id={vehicleData.thirdId} list={true} link/>
            <span class="badge bg-primary rounded-pill">
              <button
                class="btn btn-primary btn-sm"
                type="button"
                on:click={() => {
                  addThird = true;
                  thirdId = vehicleData.thirdId;
                  type = 'third'
                }}>
                <Icon name="arrow-counterclockwise" /> Cambiar
              </button>
            </span>
          </li>
        </ul>

        <div class="form-group" />
      </div>
    {/if}
  </div>
{/if}

<AddThirdModal
  open={addThird}
  {thirdId}
  {toggle}
  on:changeThird={(event) => addNewThird(event.detail, type)}
/>

<style>
</style>
